import { useContext } from "react";

import { useTranslation } from "react-i18next";

import TableIsEmptyIcon from "assets/customIcons/emptyTable/TableIsEmptyIcon";
import AuthContext from "context/auth/authContext";
import TableContext from "context/table/tableContext";
import { TABLE_NAMES } from "shared";

import { useDialog } from "../Actions/ActionBar/hooks";
import AddDevice from "../Actions/dialogs/Devices/AddDevice";
import AddProductCode from "../Actions/dialogs/ProductCodes/AddProductCode";
import { DEVICE_ACTIONS, PRODUCT_CODE_ACTIONS } from "../Actions/types";
import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "../DesignComponents/Button";
import { useSharedContainerStyle } from "./hooks";

const NoInitialResults = () => {
    const { isAdminUser, isAdminManagerUser } = useContext(AuthContext);
    const { tableName } = useContext(TableContext);

    const { t } = useTranslation();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();
    const sharedStyle = useSharedContainerStyle();

    const isAddDevice = tableName === TABLE_NAMES.Devices && isAdminUser;

    const isAddProductCode =
        tableName === TABLE_NAMES.ProductCodes && isAdminManagerUser;

    const isButtonDisplayed = isAddDevice || isAddProductCode;

    const handleOpen = () => {
        const action = isAddDevice
            ? DEVICE_ACTIONS.AddDevice
            : PRODUCT_CODE_ACTIONS.AddProductCode;

        openDialog(action);
    };

    return (
        <div css={sharedStyle}>
            <TableIsEmptyIcon />

            <div>
                <div>
                    {t(
                        `Table##empty table##no initial results##title##${tableName}`
                    )}
                </div>

                <div>
                    {t(
                        `Table##empty table##no initial results##description##${tableName}`
                    )}
                </div>
            </div>

            {isButtonDisplayed && (
                <>
                    <Button
                        color={BUTTON_COLORS.Primary}
                        size={BUTTON_SIZES.Small}
                        variant={BUTTON_VARIANTS.TextOnly}
                        onClick={handleOpen}
                    >
                        {t(`Table##empty table##button##add##${tableName}`)}
                    </Button>

                    <AddDevice
                        isOpen={isOpenDialog[DEVICE_ACTIONS.AddDevice]}
                        close={closeDialog}
                    />

                    <AddProductCode
                        isOpen={
                            isOpenDialog[PRODUCT_CODE_ACTIONS.AddProductCode]
                        }
                        close={closeDialog}
                    />
                </>
            )}
        </div>
    );
};

export default NoInitialResults;
